import {getOrigin, getDestination, updateOrigin, updateDestination} from '@/store/state/helpers';
import {computed} from '@vue/composition-api';
import {ProblemDestination} from '@/store/state/global.types';
import {POISearchOption} from '@/store/api/search-poi';

export function useContent() {
  const origin = computed<ProblemDestination | null>(() => {
    return getOrigin();
  });

  const destination = computed<ProblemDestination | null>(() => {
    return getDestination();
  });

  const onOriginChange = (value: POISearchOption | null) => {
    updateOrigin(value);
  };

  const onDestinationChange = async (value: POISearchOption | null) => {
    updateDestination(value);
  };

  return {
    origin,
    destination,
    onOriginChange,
    onDestinationChange,
  };
}
